import { Component, OnInit, ViewChild } from '@angular/core';
import { AuditService } from 'src/app/services/panelM/audit.service';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.scss']
})
export class AuditComponent implements OnInit {
  listAudit: any;
  search: UntypedFormGroup;
  aux: any;
  placeHolder: string;
  displayedColumns: string[] = ['IdUsuario', 'IdRequest', 'ExecutionId', 'EXEC_UUID', 'Robot', 'Status', 'ResponseCode', 'StartTime', 'EndTime'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private readonly auditService: AuditService, private router: Router, private fBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.search = this.fBuilder.group({
      result: new UntypedFormControl('', []),
      select: new UntypedFormControl('', [])
    }, {});
    this.auditService.auditService().subscribe((data: any) => {
      this.aux = data.AuditList;
      this.searchItem();
      this.listAudit = new MatTableDataSource<any>(data.AuditList);
      this.listAudit.paginator = this.paginator;
    }, (err) => {
      console.error(err);
      this.router.navigateByUrl('/portalM');
    });
  }

  searchItem() {
    this.search.valueChanges.subscribe(data => {
      const v = this.search.get('result').value;
      this.placeHolder = data.select;
      if (v === '') {
        this.listAudit = new MatTableDataSource<any>(this.aux);
        this.listAudit.paginator = this.paginator;
        return;
      } else {
        this.listAudit = new MatTableDataSource<any>(this.aux.filter(d => d[this.placeHolder].toString().includes(v.trim())));
        this.listAudit.paginator = this.paginator;
      }
    });
  }

}
